/**
 * useSchema — GET /enterprise/connectors/{conn_id}/schema.
 *
 * Read-only TanStack query. The schema is materialised by the BE
 * discovery + profiling pipeline (see ``useDiscoverSchema``); this hook
 * just surfaces it. Cache lifetime is 5 minutes — schemas don't change
 * outside of an explicit re-discovery, and we want navigation between
 * tables in the viewer to feel instant.
 */

import { useQuery } from "@tanstack/react-query";

import { type SchemaResponse, getEnterpriseSchema } from "@ando/core/api";

import { enterpriseSchemaKey } from "./enterpriseKeys";

const STALE_MS = 5 * 60_000;

export interface UseSchemaOptions {
  readonly enabled?: boolean;
}

export function useSchema(connId: string, { enabled = true }: UseSchemaOptions = {}) {
  return useQuery<SchemaResponse>({
    queryKey: enterpriseSchemaKey(connId),
    queryFn: () => getEnterpriseSchema(connId),
    enabled: enabled && connId.length > 0,
    staleTime: STALE_MS,
    retry: 1,
  });
}
